import type { ReactNode } from 'react'

import { TABS, type TabKey } from '@/context'
import { cn } from '@/lib/utils'

/**
 * Standard screen header: title in Fraunces + a one-line RO subtitle, with an
 * optional actions slot on the right. Pass `tab` to pull the label/description
 * from TABS, or override with explicit `title` / `subtitle`.
 */
export function ScreenHeader({
  tab,
  title,
  subtitle,
  children,
  className,
}: {
  tab?: TabKey
  title?: string
  subtitle?: string
  children?: ReactNode
  className?: string
}) {
  const def = tab ? TABS.find((t) => t.key === tab) : undefined
  const t = title ?? def?.label ?? ''
  const s = subtitle ?? def?.descriere ?? ''
  return (
    <div className={cn('mb-6 flex flex-wrap items-end justify-between gap-4', className)}>
      <div className="min-w-0">
        <h1 className="font-display text-2xl font-medium tracking-tight sm:text-3xl">{t}</h1>
        {s && <p className="mt-1 text-sm text-muted-foreground">{s}</p>}
      </div>
      {children && <div className="flex shrink-0 items-center gap-2">{children}</div>}
    </div>
  )
}
